import { render, staticRenderFns } from "./itemshop.vue?vue&type=template&id=41b602d4&scoped=true"
import script from "./itemshop.vue?vue&type=script&lang=js"
export * from "./itemshop.vue?vue&type=script&lang=js"
import style0 from "./itemshop.vue?vue&type=style&index=0&id=41b602d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b602d4",
  null
  
)

export default component.exports